<template>
  <div id="app">
    <Header v-if="!hiddenHeaderRoute.includes($route.name)"></Header>
    <Header2 v-else></Header2>
    <router-view/>
    <!-- 占位box -->
    <!-- <div class="blank-box"><br/></div> -->
    <Footer v-show="!hiddenfooter.includes($route.name)"></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Header2 from '@/components/Header2'
import Footer from '@/components/Footer'
export default {
  name: 'App',
  data() {
    return {
      hiddenHeaderRoute: ['home'],
      hiddenfooter: ['home', 'QA']
    }
  },
  components: {
    Header,Footer,Header2
  },
  mounted () {
    this.visit()
  },
  methods: {
    visit() {
      // function ipCallback(i) {
      //   this.ip = i.ip
      // }
      this.$axios
        .get("https://dataexpo.acemap.info/api/v2/ip/visit?ip=")
        .then((response) => {
          this.$store.commit("updateUserIp", response.data.ip_x_forwarded_for);
        });
    },
  }
  
}
</script>

<style>
@import "../static/reset.css";
</style>
<style lang="less">
  @import "./main.less";
  #app {
    background: #fff;
  }
</style>
